import "@splidejs/react-splide/css";
import "./Carousel.css";

import { ReactElement, useMemo } from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";

type CarouselProps = {
  itemsPerSlide: number;
  ariaLabel: string;
  onUpdated?: (e: any) => any;
  children: ReactElement[];
};

export const Carousel = ({ itemsPerSlide, ariaLabel, onUpdated, children }: CarouselProps) => {
  const slides = useMemo(() => {
    const slides: ReactElement[] = [];

    for (let index = 0; index < children.length; index += itemsPerSlide) {
      const slideElements = children.slice(index, index + itemsPerSlide);
      slides.push(<SplideSlide key={`slide-${slides.length}`}>{slideElements}</SplideSlide>);
    }

    return slides;
  }, [children, itemsPerSlide]);

  return (
    <Splide onMove={onUpdated && ((_splide, index) => onUpdated(index))} hasTrack={false} options={{ label: ariaLabel, gap: "2rem" }}>
      <SplideTrack>{slides}</SplideTrack>
      <div className="splide__pagination" />
      <div className="hidden splide__arrows" />
    </Splide>
  );
};
